export default __webpack_public_path__ + "static/media/Searing Sword.bdcab948.jpg";